<template>
  <div>
    <modal
      :title="$t('ui.segments.add_to_project_modal.title')"
      :open="addToProjectModalOpen"
      @save="addToProject()"
      :saveText="$t('ui.segments.add_to_project_modal.add_button')"
      @cancel="closeAddToProjectModalOpen()"
      class="businesskit-modal"
      :saveDisabled="!project.id"
    >
      <div v-if="projects.length > 0">
        <auto-complete
          class="add_to_project-autocomplete"
          model="organization-projects"
          type="text"
          label="empty"
          name="value"
          :item="project"
          init="none"
          @change="selectProject"
          :autofocus="true"
          :placeholder="$t('ui.segments.add_to_project_modal.search_label')"
        ></auto-complete>
      </div>
      <div v-else>
        {{$t('ui.segments.add_to_project.empty')}}
      </div>
    </modal>
  </div>
</template>

<script>
import ContactsApi from "@/api/Contacts";
import ProjectApi from "@/api/Project"
import Modal from '@/components/helpers/Layout/NewModal'
import Field from '@/components/helpers/DataInput/Field'
import AutoComplete from "@/components/helpers/DataDisplay/AutoComplete"

export default {
  components: { Modal, Field, AutoComplete },
  props: {
    segment: {
      type: Object,
      default: {}
    },
    addToProjectModalOpen: {
      type: Boolean,
      default: false
    },
    contactIds: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      projects: [],
      project: {
        id: null,
        value: '',
      },
    };
  },
  async mounted() {
    this.retrieveProjects();
  },
  methods: {
    selectProject(value) {
      this.project.id = value.id
      this.project.value = value.name
    },
    retrieveProjects() {
      let projectApi = new ProjectApi()

      projectApi.getAll().then((result) => {
        var projects = []

        result.resources.forEach((p) => {
          projects.push({
            "name": p.name,
            "value": p.id,
          })
        })

        this.projects = projects
      })
    },
    closeAddToProjectModalOpen() {
      this.project = {
        id: null,
        value: '',
      },
      this.$emit('closeAddToProjectModal');
    },
    async addToProject() {
      let contactsApi = new ContactsApi();

      let response = await contactsApi.addToProject({
        projectId: this.project.id,
        segmentId: this.segment.id,
        organizationId: this.segment.organization.id,
        contactIds: this.contactIds
      })

      if (response.status == 204) {
        this.closeAddToProjectModalOpen();

        this.$store.commit("SET_NOTIFICATION", {
          title: "ui.segments.add_to_project.success",
          type: "success",
          duration_ms: 0,
        });
      } else {
        this.closeAddToProjectModalOpen();

        this.$store.commit("SET_NOTIFICATION", {
          title: "ui.segments.add_to_project.error",
          type: "error",
          duration_ms: 0,
        });
      }
    },
  }
}
</script>

<style lang="sass">
  .businesskit-modal
    .title-subtext
      color: #9198AC;

    .modal-component
      overflow-y: initial;
      overflow-x: initial;

    .businesskit-header-modal
      width: 480px;

      img
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        width: 100%;
</style>



// WEBPACK FOOTER //
// AddToProjectModal.vue?62e399b8